import React from 'react';
import ReactDOM from 'react-dom/client';
import './assets/main.css';
import App from './App.jsx';
import { BannerActivist } from './components/BannerActivist.js';
import { BrowserRouter } from 'react-router-dom';

const root4 = ReactDOM.createRoot(document.getElementById('root4'));
root4.render(
  
  <React.StrictMode>
    <BrowserRouter>
       <App />
    </BrowserRouter>
  </React.StrictMode>
);
const root3 = ReactDOM.createRoot(document.getElementById('root3'));
root3.render(
  
  <React.StrictMode>
    <BannerActivist />
  </React.StrictMode>
);
